import { parseAsInteger, parseAsString, parseAsStringLiteral } from "nuqs"
import type { StoreSortBy, StoreSortOrder } from "./contract"

const DEFAULT_PER_PAGE = 12

export const storeProductsQueryParsers = {
  q: parseAsString.withDefault(""),
  orderby: parseAsStringLiteral<StoreSortBy>([
    "menu_order",
    "date",
    "id",
    "title",
    "popularity",
    "rating",
  ]).withDefault("menu_order"),
  order: parseAsStringLiteral<StoreSortOrder>(["asc", "desc"]).withDefault(
    "asc"
  ),
  per_page: parseAsInteger.withDefault(DEFAULT_PER_PAGE),
}

export const storeTabParser = parseAsStringLiteral(["products", "reviews"])
  .withDefault("products")
  .withOptions({
    history: "replace",
    shallow: true,
  })

export const storeReviewsPageParser = parseAsInteger
  .withDefault(1)
  .withOptions({
    history: "push",
    shallow: true,
  })
